<script>
import axios from "axios";

export default {
  props: {
    visible: {
      required: false,
      default: false,
    },
    aforo: {
      type: [Object],
      required: true,
    },
  },
  emits: ["refetch", "close-modal"],
  data() {
    return {
      selected: {
        status: undefined,
      },
    };
  },
  methods: {
    async updateStatus() {
      const query = {
        estado: this.selected.status,
      };

      try {
        await axios.post(
          `/api/admin/aforos/${this.aforo.id}/actualizar-estado`,
          query
        );

        this.$emit("refetch");
        this.$emit("close-modal");
      } catch (e) {
        console.error("There was a problem updating a document status:", e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al actualizar el estado del aforo.",
        });
      }
    },
  },
  watch: {
    visible: function (newValue) {
      if (newValue == true) {
        this.selected.status = this.aforo?.estado;
      }
    },
  },
};
</script>

<template>
  <b-modal v-model="visible">
    <template #modal-title> Cambiar estado </template>
    <div class="flex flex-col gap-4">
      <select v-model="selected.status">
        <option value="Presentado">Presentado</option>
        <option value="Sin observaciones">Sin observaciones</option>
        <option value="Retirado con multa">Retirado con multa</option>
        <option value="Retención">Retención</option>
      </select>
    </div>

    <template #modal-footer>
      <div class="flex flex-row items-center gap-2 justify-end">
        <button class="btn-cancelar" @click="() => $emit('close-modal')">
          Cancelar
        </button>
        <button class="btn-principal" @click="updateStatus()">Guardar</button>
      </div>
    </template>
  </b-modal>
</template>
